import { type FC } from 'react'
import { Form } from 'react-bootstrap'

interface MeetingNameFieldProps {
  title: string
  onTitleChange: (title: string) => void
}

export const MeetingNameField: FC<MeetingNameFieldProps> = ({ title, onTitleChange }) => (
  <div className='d-flex flex-column zocks-gap-0.25 p-3 border zocks-border-color-gray-200 zocks-border-1.0'>
    <label className='bold' htmlFor='schedule-meeting-name'>
      Meeting name
    </label>
    <div className='paragraph-small zocks-text-gray-600'>Your calendar invite will be named this</div>
    <Form.Control id='schedule-meeting-name' type='text' value={title} onChange={(event) => onTitleChange(event.currentTarget.value)} />
    <div className='paragraph-small zocks-text-gray-500'>Suggested from clients, owner and event type. Edit anytime.</div>
  </div>
)
